/* Barre de livraison offerte multi-devises (Mothersocker). Chargé globalement dans layout/theme.liquid. */
(function () {
  if (window.__msFsbInit) return;
  window.__msFsbInit = true;

  function getRate(el) {
    if (el.dataset.currency === el.dataset.shopCurrency) return 1;
    var c = window.Shopify && window.Shopify.currency;
    var r = c && parseFloat(c.rate);
    return r && !isNaN(r) && r > 0 ? r : null;
  }

  function fmt(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  // Une barre doit être (re)calculée si elle est en attente ou si son message n'a pas été rendu
  function needsRender(el) {
    return el.classList.contains('free-shipping-bar--pending') ||
      !el.querySelector('.free-shipping-bar__message span') ||
      el.dataset.fsbRendered !== el.dataset.cartTotal;
  }

  function render(el) {
    var rate = getRate(el);
    if (rate === null) {
      el.style.display = 'none';
      return;
    }
    var threshold = Math.round(parseInt(el.dataset.threshold, 10) * rate);
    var total = parseInt(el.dataset.cartTotal, 10) || 0;
    var left = threshold - total;
    var free = left <= 0;
    var pct = Math.min(Math.floor(total * 100 / threshold), 100);
    var currency = el.dataset.currency;
    var locale = el.dataset.locale;
    var intl = el.dataset.country === 'FR' ? 'en France' : 'à l’international';

    var msg = el.querySelector('.free-shipping-bar__message');
    if (msg) {
      if (el.dataset.lang === 'fr') {
        msg.innerHTML = free
          ? '<span>Les frais de port sont offerts !</span>'
          : '<span class="free-shipping-bar__notice">Vous êtes à ' + fmt(left, currency, locale) + ' de profiter des frais de port offerts ' + intl + ' !</span>';
      } else {
        msg.innerHTML = free
          ? '<span>Free shipping is available!</span>'
          : '<span class="free-shipping-bar__notice">You are ' + fmt(left, currency, locale) + ' away from free shipping!</span>';
      }
    }

    var fill = el.querySelector('.free-shipping-bar__fill');
    if (fill) fill.style.width = pct + '%';

    var icon = el.querySelector('.free-shipping-bar__icon');
    if (icon) icon.classList.toggle('free-shipping-bar__icon--unlocked', free);

    el.dataset.fsbRendered = el.dataset.cartTotal;
    el.classList.remove('free-shipping-bar--pending');
  }

  function refreshPending() {
    document.querySelectorAll('.free-shipping-bar').forEach(function (el) {
      if (needsRender(el)) render(el);
    });
  }
  window.__msFsbRefresh = refreshPending;

  // Savor met à jour le panier par "morph" : il réécrit les attributs et le contenu
  // de la barre existante (classe pending, message vide) au lieu d'insérer un nouvel élément.
  // On surveille donc ajouts de noeuds ET changements de classe, puis on recalcule.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refreshPending();
    });
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (el && el.closest && el.closest('.free-shipping-bar')) { schedule(); return; }
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('.free-shipping-bar') || n.querySelector('.free-shipping-bar'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-cart-total']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshPending);
  } else {
    refreshPending();
  }
})();